import React from "react";
import styled from "styled-components";
import slugify from "slugify";

import baseStyles from "../../styles/baseStyles";
import { navigateTo } from "gatsby-link";

const NavWrapper = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  border-bottom: 2px solid transparent;
  border-top: 2px solid transparent;
  flex: 1;
  padding: 0 1rem;
  cursor: pointer;
  transition: 0.3s all ease-in;
  border-bottom: ${props =>
    props.isActive
      ? `2px solid ${baseStyles.color.primary}`
      : `2px solid transparent`};
  > h2 {
    color: ${props =>
      props.isActive
        ? `${baseStyles.color.primary}`
        : `${baseStyles.color.white2}`};
  }
  :hover {
    > h2 {
      color: ${baseStyles.color.primary};
    }
  }
`;

const NavItemTitle = styled.h2`
  transition: 0.3s all ease-in;
  font-family: Lato;
  font-size: 15px;
  color: ${baseStyles.color.white2};
  letter-spacing: 1.2px;
  text-transform: uppercase;
  font-weight: 400;
  margin: 0 0 0 0.5rem;
  padding: 0;
`;

const Flag = styled.img`
  height: 1.5rem;
`;

const NavItem = ({ icon: { url }, name, isActive }) => (
  <NavWrapper
    isActive={isActive}
    onClick={() => navigateTo(`/nordics/${slugify(name, { lower: true })}`)}
  >
    <Flag src={url} alt={name} />
    <NavItemTitle>{name}</NavItemTitle>
  </NavWrapper>
);

export default NavItem;



// WEBPACK FOOTER //
// ./src/components/CountryNavigator/NavItem.js